var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTidal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".tidal-icon-circle-1{fill:#231f20;}.tidal-icon-circle-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tidal_circle icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "tidal-icon-circle-1",
    d: "M45,22.5a22.5,22.5,0,1,0-6.59,15.91A22.5,22.5,0,0,0,45,22.5Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "tidal-icon-circle-2",
    d: "M10.94,13.45H11c.55.63,1.16,1.18,1.74,1.78l4,4v.07L11,25,5.22,19.24a2.35,2.35,0,0,1,.43-.46C7.41,17,9.19,15.24,10.94,13.45Z",
    transform: "translate(0 0)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "tidal-icon-circle-2",
    d: "M22.47,13.45h.07a1.41,1.41,0,0,0,.18.22c1.85,1.83,3.67,3.69,5.54,5.52a.88.88,0,0,1-.22.26L22.5,25c-1.93-1.9-3.83-3.84-5.77-5.74C18.61,17.29,20.58,15.4,22.47,13.45Z",
    transform: "translate(0 0)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "tidal-icon-circle-2",
    d: "M34,13.45h.07c.36.43.78.8,1.16,1.2L39.57,19c.07.08.19.15.21.27C37.84,21.14,36,23.1,34,25l-5.5-5.5c-.09-.1-.21-.17-.25-.3,1-.95,1.92-1.92,2.89-2.88S33.07,14.43,34,13.45Z",
    transform: "translate(0 0)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "tidal-icon-circle-2",
    d: "M16.81,30.66,22.48,25l.08,0q2.84,2.86,5.7,5.69c-.06.14-.2.22-.3.34l-4.13,4.12c-.45.43-.88.91-1.33,1.31-.65-.59-1.25-1.25-1.89-1.86-1.29-1.29-2.57-2.57-3.86-3.85l.05-.13Z",
    transform: "translate(0 0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTidal);
export default __webpack_public_path__ + "static/media/tidal.06713355bf7c2b36ea291a4e2da0d6d1.svg";
export { ForwardRef as ReactComponent };